module.exports = "        <div *ngFor=\"let s of statuslist\" style=\"display: inline;\">\r\n            <mat-checkbox [(ngModel)]=\"s.selected\">\r\n                <div style=\"left: 0;\">{{s.name}}</div>\r\n            </mat-checkbox>\r\n        </div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/a0106-mail/a-status-list.component.html
// module id = ./src/app/a0106-mail/a-status-list.component.html
// module chunks = main